import { useCallback } from "react";
import { useKlaviyo } from "./useKlaviyo";

import { useLogout } from "./useSession";

/**
 * Legacy hook used for logging out a customer.
 *
 * @todo Remove this when no longer need to do the wishlist stuff.
 */
export const useCustomerLogout = () => {
  const logout = useLogout();

  const { track } = useKlaviyo();

  const logoutCustomer = useCallback(async () => {
    // Logout of server-side session.
    await logout();

    track("Account Logout", false);

    /**
     * Do a hard navigate instead of a Gatsby navigate, as we want the new session cookies
     * to be used for the SSR request.
     */
    window.location.href = "/account/login";
  }, [logout]);

  return { logoutCustomer };
};
